import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import FeaturedVidCard from "./FeaturedVidCard";
import VideoModal from "./VideoModal";
import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import { ChevronLeft, ChevronRight } from "lucide-react";

function FeaturedVideos() {
    const navigate = useNavigate();
    const [videos, setVideos] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const sliderRef = useRef(null);

    useEffect(() => {
        let isMounted = true;
        const langEl = document.getElementById('language');
        const language = langEl ? langEl.value : '1';
        axios.get(`${API_BASE_URL}/vedios/${language}`).then((res) => {
            if (isMounted && res.data.vedios) setVideos(res.data.vedios);
        }).catch(err => console.error("FeaturedVideos error:", err));
        return () => { isMounted = false; };
    }, []);

    const handleVideoClick = (video) => {
        setSelectedVideo(video);
        setIsModalOpen(true);
    };

    function scroll(dir) {
        if (!sliderRef.current) return;
        const gap = 24;
        const cardW = (sliderRef.current.offsetWidth - gap * 3) / 4;
        sliderRef.current.scrollBy({ left: dir * (cardW + gap), behavior: 'smooth' });
    }

    return (
        <div id="videos-container" style={{
            maxWidth: 'var(--maxWidth)',
            margin: '0 auto',
            padding: '0 24px',
            marginBottom: '60px', // Increased spacing
        }}>
            {/* Header */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '24px',
            }}>
                <h2 style={{
                    fontFamily: 'var(--fontDisplay)',
                    fontSize: '28px', // Standard desktop size
                    fontWeight: 800,
                    color: '#000',
                    margin: 0,
                    textTransform: 'uppercase',
                    letterSpacing: '1px'
                }}>Videos</h2>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <span
                        onClick={() => navigate('/videos-list')}
                        style={{ 
                            fontFamily: 'var(--fontRajdhani)', 
                            fontWeight: 600, 
                            fontSize: '16px', 
                            textDecoration: 'underline', 
                            color: 'var(--blue)', 
                            cursor: 'pointer' 
                        }}
                    >View More</span>
                    
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={() => scroll(-1)} style={arrowStyle}>
                            <ChevronLeft size={18} color="#fff" />
                        </button>
                        <button onClick={() => scroll(1)} style={arrowStyle}>
                            <ChevronRight size={18} color="#fff" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Slider row */}
            <div
                ref={sliderRef}
                style={{
                    display: 'flex',
                    gap: '24px',
                    overflowX: 'auto',
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    scrollSnapType: 'x mandatory',
                    paddingBottom: '16px',
                }}
            >
                {videos.map((video, i) => (
                    <div key={i} className="vid-card-wrap">
                        <FeaturedVidCard data={video} onClick={handleVideoClick} />
                    </div>
                ))}
            </div>

            {/* Cinematic Video Modal */}
            <VideoModal 
                video={selectedVideo} 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)} 
            />

            <style>{`
                #videos-container div::-webkit-scrollbar { display: none; }
                .vid-card-wrap {
                    flex: 0 0 calc(25% - 18px);
                    min-width: 0;
                    scroll-snap-align: start;
                }
                @media (max-width: 1024px) {
                    .vid-card-wrap { flex: 0 0 calc(50% - 12px); }
                }
                @media (max-width: 600px) {
                    .vid-card-wrap { flex: 0 0 calc(100% - 0px); }
                }
            `}</style>
        </div>
    );
}

const arrowStyle = {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: '#0a1172',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'background 0.2s',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
};

export default FeaturedVideos;
